import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=025977f6&"
import script from "./HomeSection.vue?vue&type=script&lang=js&"
export * from "./HomeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports